import { IUser } from '@/pages/Users/users.types.ts'
import SidePage from '@/shared/SidePage'
import { useEffect, useState } from 'react'
import ViewUserSidePageContent from '@/pages/Users/components/UserSidePage/ViewUserSidePageContent'
import EditUserSidePageContent from '@/pages/Users/components/UserSidePage/EditUserSidePageContent'

interface IProps {
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
  user: IUser
}

const UserSidePage = (props: IProps) => {
  const [mode, setMode] = useState<'view' | 'edit'>('view')

  useEffect(() => {
    setMode('view')
  }, [props.user.id])

  const renderContent = () => {
    if (mode === 'view') {
      return <ViewUserSidePageContent onEdit={() => setMode('edit')} onClose={props.onClose} user={props.user} />
    }

    return <EditUserSidePageContent user={props.user} onCancel={() => setMode('view')} />
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.user) return null

  return <UserSidePage {...props} />
}
